import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useLanguage } from "../../context/LanguageContext";

// Helper: replace {placeholder} tokens in a string with <span className="purple"> elements
function Highlighted({ text, tokens }) {
  let parts = [text];
  tokens.forEach(({ placeholder, keyword }) => {
    parts = parts.flatMap((part) => {
      if (typeof part !== "string") return [part];
      const split = part.split(placeholder);
      return split.flatMap((seg, i) =>
        i < split.length - 1
          ? [seg, <span className="purple" key={placeholder + i}>{keyword}</span>]
          : [seg]
      );
    });
  });
  return <>{parts}</>;
}

function AboutCard() {
  const { t } = useLanguage();
  const c = t.about.card;

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <Highlighted
              text={c.p1}
              tokens={[
                { placeholder: "{name}", keyword: "Dang Ngoc Tien" },
                { placeholder: "{role}", keyword: "Backend Developer" },
              ]}
            />
            <br />
            <br />
            <Highlighted
              text={c.p2}
              tokens={[
                { placeholder: "{exp}", keyword: "3 years of experience" },
                { placeholder: "{java}", keyword: "Java" },
                { placeholder: "{springboot}", keyword: "Spring Boot" },
                { placeholder: "{kafka}", keyword: "Kafka" },
                { placeholder: "{postgres}", keyword: "PostgreSQL" },
                { placeholder: "{oracle}", keyword: "Oracle" },
              ]}
            />
            <br />
            <br />
            <Highlighted
              text={c.p3}
              tokens={[
                { placeholder: "{micro}", keyword: "microservices architecture" },
                { placeholder: "{dbopt}", keyword: "database optimization" },
                { placeholder: "{distributed}", keyword: "distributed systems" },
                { placeholder: "{traffic}", keyword: "traffic management" },
                { placeholder: "{gov}", keyword: "government-scale platforms" },
              ]}
            />
            <br />
            <br />
            {c.p4}
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> {c.hobby1}
            </li>
            <li className="about-activity">
              <ImPointRight /> {c.hobby2}
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>{c.quote}</p>
          <footer className="blockquote-footer">Dang Ngoc Tien</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
